import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';

import MUI from './Mui';

const MUITitle = ({ content }) => {
  const beforeProps = {
    mobile: content.ibXS,
    tablet: content.ibSM,
    laptop: content.ibMD,
    desktop: content.ibLG,
    qhd: content.ibXL,
    uhd: content.ibXLL,
  };

  const afterProps = {
    mobile: content.iaXS,
    tablet: content.iaSM,
    laptop: content.iaMD,
    desktop: content.iaLG,
    qhd: content.iaXL,
    uhd: content.iaXLL,
  };

  const typeProps = {
    mobile: content.typeXS,
    tablet: content.typeSM,
    laptop: content.typeMD,
    desktop: content.typeLG,
    qhd: content.typeXL,
    uhd: content.typeXLL,
  };

  return(
    <Grid
      container
      className={`Title ${content.className}`}
      spacing={content.spacing || 0}
      direction={content.direction || 'row'}
      justifyContent={content.justifyContent || 'flex-start'}
      flexWrap={content.flexWrap || 'nowrap'}
      alignItems={content.alignItems || 'center'}
      sx={{
        margin: content.margin || 0,
        padding: content.padding || 0,
      }}
    >
      {(content.iconBefore || content.imageBefore) && (
        <Grid
          {...beforeProps}
        >
          {content.iconBefore && (
            <MUI
              type={'mui.svg-icon'}
              content={content.iconBefore}
            />
          )}
          {content.imageBefore && (
            <MUI
              type={'mui.media'}
              content={content.imageBefore}
            />
          )}
        </Grid>
      )}
      
      <Grid
        {...typeProps}
      >
        {content.title && (
          <MUI
            type={'mui.typography'}
            content={content.title}
          />
        )}
        {content.subtitle && (
          <MUI
            type={'mui.typography'}
            content={content.subtitle}
          />
        )}
      </Grid>

      {(content.iconAfter || content.imageAfter) && (
        <Grid
          {...afterProps}
        >
          {content.iconAfter && (
            <MUI
              type={'mui.svg-icon'}
              content={content.iconAfter}
            />
          )}
          {content.imageAfter && (
            <MUI
              type={'mui.media'}
              content={content.imageAfter}
            />
          )}
        </Grid>
      )}
    </Grid>
  );
}

export default MUITitle;